// extracted by mini-css-extract-plugin
module.exports = {"modal":"CopytToNormalModal_modal__2ocji","well":"CopytToNormalModal_well__1MCHX","field":"CopytToNormalModal_field__GQCKg"};